<template>
  <v-dialog v-if="item" v-model="dialog" max-width="1300">
    <v-row :no-gutters="mobile">
      <v-col
        cols="12"
        md="2"
        :class="{
          'pr-0': !mobile,
          'pb-7': !mobile,
          'pa-0': mobile,
          'pb-0': mobile
        }"
      >
        <v-card
          :class="{
            'pt-2': true,
            'card-check-behind': !mobile,
            'card-check': mobile,
            'pa-4': !mobile,
            'px-6': !mobile,
            'px-4': mobile,
            'pb-0': mobile,
            'd-flex': true,
            'flex-column': true,
            'justify-space-around': !mobile,
            'rounded-bl-0': mobile,
            'rounded-br-0': mobile
          }"
          :elevation="!mobile ? 8 : 0"
        >
          <div>
            <p class="caption">Sequence #</p>
            <p>
              <b>{{ item.refNo }}</b>
            </p>
          </div>
          <div>
            <p class="caption">Payment Request #</p>
            <p>
              <b>{{ item.paymentRefNo }}</b>
            </p>
          </div>
          <div class="mt-0">
            <p class="caption">Payment Category:</p>
            <p>{{ item.category }}</p>
          </div>
          <div>
            <p :class="{ caption: true, 'mt-1': mobile }">
              Valid for the period:
            </p>
            <p>
              <strong>{{ formatDate(item.startDate) || 'x' }}</strong>
            </p>
            <p :class="{ caption: true, 'mt-2': !mobile, 'mt-1': mobile }">
              until:
            </p>
            <p>
              <strong>{{ formatDate(item.endDate) || 'x' }}</strong>
            </p>
          </div>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="10"
        :class="{
          'pl-0': !mobile,
          'pa-0': mobile
        }"
      >
        <v-card
          :class="{
            'mb-4': true,
            'px-4': !mobile,
            'pl-8': !mobile,
            'pb-6': !mobile,
            'pt-2': !mobile,
            'card-check': true,
            'rounded-tl-0': mobile,
            'rounded-tr-0': mobile
          }"
          :elevation="!mobile ? 8 : 0"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="3"
                :class="{ 'pr-1': !mobile, 'py-0': true }"
              >
                <v-text-field
                  outlined
                  dense
                  hint="Tenant *"
                  persistent-hint
                  readonly
                  :value="item.tenantName"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="3"
                :class="{ 'pr-1': !mobile, 'py-0': true }"
              >
                <v-text-field
                  outlined
                  dense
                  hint="Unit *"
                  persistent-hint
                  readonly
                  :value="getUnitName()"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="2"
                :class="{ 'pr-1': !mobile, 'py-0': true }"
              >
                <v-text-field
                  solo
                  flat
                  dense
                  hint="Routing Number"
                  persistent-hint
                  readonly
                  :value="item.routingNumber"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="2"
                :class="{ 'pr-1': !mobile, 'py-0': true }"
              >
                <v-text-field
                  solo
                  flat
                  dense
                  hint="Account Number *"
                  persistent-hint
                  readonly
                  :value="item.accountNumber"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="2"
                :class="{ 'pr-1': !mobile, 'py-0': true }"
              >
                <v-text-field
                  solo
                  flat
                  dense
                  hint="Check Number *"
                  persistent-hint
                  readonly
                  :value="item.checkNumber"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="9"
                :class="{ 'pr-1': !mobile, 'pb-0': true }"
              >
                <v-text-field
                  dense
                  label="Pay to the order of"
                  :placeholder="property.propertyName"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="3"
                :class="{ 'pr-1': !mobile, 'pb-0': true }"
              >
                <v-text-field
                  outlined
                  dense
                  hint="Check Date *"
                  persistent-hint
                  readonly
                  :value="formatDate(item.dueDate)"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="8"
                :class="{ 'pr-1': !mobile, 'pt-0': true }"
              >
                <v-textarea
                  outlined
                  dense
                  hint="Description"
                  persistent-hint
                  readonly
                  :value="item.description"
                  rows="1"
                  auto-grow
                ></v-textarea>
              </v-col>
              <v-col
                cols="12"
                md="4"
                :class="{ 'pr-1': !mobile, 'pt-0': true }"
              >
                <v-currency-field
                  outlined
                  dense
                  hint="Amount (Rent Fee) *"
                  persistent-hint
                  readonly
                  :value="item.amount"
                  disabled
                ></v-currency-field>
              </v-col>
              <!-- <v-col cols="12" md="3" :class="{'pr-1': !mobile, 'py-0': true}">
                <v-text-field solo flat dense label="Attachments"></v-text-field>
              </v-col> -->
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="4"
                :class="{ 'pr-1': !mobile, 'py-0': true }"
              >
                <v-text-field
                  solo
                  flat
                  dense
                  hint="Bank / Branch *"
                  persistent-hint
                  readonly
                  :value="item.bank"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="3"
                :class="{ 'pr-1': !mobile, 'py-0': true }"
              >
              </v-col>
              <v-col
                cols="12"
                md="5"
                :class="{
                  'pr-1': !mobile,
                  'py-0': true,
                  'd-flex': true,
                  'justify-end': !mobile,
                  'justify-center': mobile
                }"
              >
                <v-chip-group v-if="item.attachments.length">
                  <v-chip
                    v-for="attachment in item.attachments"
                    :key="attachment.url"
                    close
                    @click="downloadAttachment(attachment)"
                    >{{ attachment.shortFilename }}</v-chip
                  >
                </v-chip-group>
                <v-btn v-else disabled>No attachments</v-btn>
              </v-col>
            </v-row>
            <v-card-actions
              :class="{
                'px-0': mobile,
                'my-4': mobile,
                'd-flex': mobile,
                'justify-center': mobile
              }"
            >
              <v-spacer v-if="!mobile"></v-spacer>
              <v-btn depressed @click="dialog = false">Close</v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-dialog>
</template>

<script>
import { dayjs } from '../../util/date'
import { truncateString } from '../../config/string'
export default {
  data() {
    return {
      item: null,
      dialog: false
    }
  },
  computed: {
    units() {
      return this.$store.getters['units/getUnitsFlat']
    },
    property() {
      return this.$store.getters['properties/getProperty']
    },
    mobile() {
      return this.$vuetify.breakpoint.xs
    }
  },
  methods: {
    open(params) {
      this.item = params.item
      this.item.attachments =
        (this.item.attachments &&
          this.item.attachments.map((attachment) => {
            if (attachment)
              attachment.shortFilename = truncateString(attachment.filename, 12)
            return attachment
          })) ||
        []

      this.dialog = true
    },
    downloadAttachment(attachment) {
      window.open(attachment.url)
    },
    formatDate(date) {
      return dayjs(date).format('MMMM DD, YYYY')
    },
    getUnitName() {
      const unit = this.units.find((u) => u.bedId === parseInt(this.item.bedId))
      return unit && unit.bedName
    }
  }
}
</script>

<style scoped>
.v-card.card-check {
  background-color: #ecebea;
}
.v-card.card-check-behind {
  background-color: #f1f2ee;
  height: 100%;
  z-index: 7;
}
.v-card.card-check-behind:after {
  top: 0;
  left: -10px;
  content: '';
  width: 10px;
  height: 100%;
  position: absolute;
  background-color: #ffffff;
  background: linear-gradient(-137deg, #f1f2ee 6px, transparent 0) 0 5px,
    linear-gradient(320deg, #f1f2ee 6px, transparent 0) 0 5px;
  background-position: left;
  background-repeat: repeat-y;
  background-size: 10px 10px;
}

.v-card.card-check-behind:after {
  left: auto;
  right: -10px;
  top: 0;
  transform: scaleX(-1);
}
</style>
